/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { DegreePlan_LearnerProgressState as LearnerProgressState } from '__generated__/graphql-types';

import { Grid, Tag, typography2 } from '@coursera/cds-core';
import { SuccessIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/degree-home';

const CompletionStatusPadding = ({ children }: React.PropsWithChildren) => (
  <Grid
    css={() => css`
      margin-bottom: var(--cds-spacing-100);
    `}
  >
    {children}
  </Grid>
);

const styles = {
  plannedTag: css`
    span {
      ${typography2.subtitleMedium}
    }
  `,
};

interface Props {
  state: LearnerProgressState;
  showPlannedCourses?: boolean;
}

/** A tag indicating a summary of the learner's progress on a course */
const CompletionStatus = ({ state }: Props) => {
  switch (state) {
    case LearnerProgressState.InProgress:
      return (
        <CompletionStatusPadding>
          <Tag variant="status" priority="primary" color="highlight1">
            {_t('In Progress')}
          </Tag>
        </CompletionStatusPadding>
      );
    case LearnerProgressState.Completed:
      return (
        <CompletionStatusPadding>
          <Tag variant="status" priority="primary" color="success" icon={<SuccessIcon />}>
            {_t('Complete')}
          </Tag>
        </CompletionStatusPadding>
      );
    case LearnerProgressState.Planned:
      return (
        <CompletionStatusPadding>
          {/* https://coursera.slack.com/archives/C058TNFJMT3/p1701287374608129: variant is category on purpose */}
          <Tag variant="category" priority="primary" color="highlight2" css={styles.plannedTag}>
            {_t('Added to plan')}
          </Tag>
        </CompletionStatusPadding>
      );
    case LearnerProgressState.NotStarted:
    default:
      return null;
  }
};

export default CompletionStatus;
